import React, { ReactElement } from 'react';
import styled from '@emotion/styled';
import { getBackgroundTheme } from '../../style';
import BackPackageIcon from '../../atoms/icons/BackPackageIcon';
import breakpoints from '../../theme/material/breakpoints';

const HeaderContainer = styled('div')({
  display: 'flex',
  position: 'relative',
  padding: '40px 0',
  [breakpoints.down('sm')]: {
    padding: '20px 0',
  },
});

const LeftContent = styled('div')({
  position: 'fixed',
  top: 60,
  left: 10,
  width: 'auto',
  height: 'auto',
  zIndex: 996,
});

const RightContent = styled('div')({
  alignItems: 'flex-end',
  textAlign: 'center',
  flex: 10,
});

// @ts-expect-error To be fix in https://reflexmedia.atlassian.net/browse/WYP-16389
const TopTitle = styled('div')(() => ({
  color: getBackgroundTheme().billingHeading,
  fontSize: 26,
  fontWeight: 600,
  textAlign: 'center',
  display: 'flex',
  alignItems: 'center',
}));

const StyledSpan = styled('span')({
  margin: 'auto',
  fontSize: 18,
  fontWeight: 700,
  letterSpacing: '-0.18px',
});

interface BillingPackageHeaderProps {
  label: string;
  onBackClick?: any;
}

const BillingPackageHeader = ({ label = '', onBackClick }: BillingPackageHeaderProps): ReactElement => {
  return (
    <HeaderContainer>
      {onBackClick && (
        <LeftContent>
          <BackPackageIcon onClick={onBackClick} data-test-id="billing-header-back" />
        </LeftContent>
      )}
      <RightContent>
        <TopTitle data-test-id="billing-header-label">
          <StyledSpan>{label}</StyledSpan>
        </TopTitle>
      </RightContent>
    </HeaderContainer>
  );
};

export default BillingPackageHeader;
